module.exports = __webpack_public_path__ + "assets/img/unknow.9a91c8d2.svg";